import { DEFAULT_ENV } from './environment.default';

export const environment = {
  ...DEFAULT_ENV,
  production: false,
  // apiBase: 'https://abelapi.chiachair.com/v1',
  // apiBase: 'http://localhost:8089/v2',
  apiBase: 'https://explorer-api.124022.xyz/v2',
  // apiBase: 'https://testnet-api.pqabelian.io/v2',
};
